import { logger } from '@/utils/logger';
import { apiService } from '@/services/api/api-client';

export type ExportAction =
  | 'inventory.export_csv'
  | 'availability.export_csv'
  | 'trades.export_csv'
  | 'mtm.export_csv';

interface ExportEventPayload {
  scope?: string;
  row_count?: number;
}

/**
 * Fire-and-forget telemetry beacon for client-side CSV exports (LR-285).
 *
 * These exports build the CSV in the browser and never hit a download endpoint,
 * so without this beacon the backend audit log never sees them. Must never throw
 * or block — a failed beacon must not break the user's download.
 */
export const recordExportEvent = (
  actionKey: ExportAction,
  payload: ExportEventPayload = {},
): void => {
  void (async () => {
    try {
      await apiService.post('/audit-events/export-event/', {
        action_key: actionKey,
        ...payload,
      });
    } catch (error) {
      logger.warn('Failed to record export event', error);
    }
  })();
};
